import { OnEventDispatcher } from "../../core/on-event-dispatcher";
import { MapSideView } from "./mapsideview";
import { Receptions, ReceptionOutDatabaseShortInfo, ReceptionOutDatabaseDetailedInfo, PlaceOpenHoursDay } from '../../io/receptions';
import { Application } from "../../main";
import { HtmlPartials } from "../../../../shared/htmlpartials";
import { GoogleMaps } from "../../core/googlemaps";
import { GPSCoordinate } from "../../core/gpscoordinate";
import { delay } from "../../core/delay";
import { GADataLayer } from "../../io/gadatalayer";

export class MapSideViewContent extends OnEventDispatcher {
    public static groupLogos:{[key:string] : string} = {
        "vaccindirekt": "static/img/group-logos/vaccindirekt_full_logo.png",
        "sveavaccin": "static/img/group-logos/sveavaccin_full_logo.png"
    };

    parent: MapSideView;
    slug: string;

    reception: ReceptionOutDatabaseShortInfo;
    receptionDetails: ReceptionOutDatabaseDetailedInfo;

    constructor(parent:MapSideView, slug:string) {
        super(); 
        this.parent = parent;
        this.slug = slug;

        (async () => {
            this.parent.clearInner();
            this.parent.elm.find(".map-sideview-inner").addClass("loading");
            let loaderElm = $('<div class="reception-details-inner-loader"><div class="spinner"><div class="lds-dual-ring"></div></div></div>').appendTo(this.parent.elm.find(".map-sideview-inner"));

            this.reception = await Receptions.getReceptionBySlug(slug);
            this.receptionDetails = await Receptions.getReceptionDetails(slug);

            //console.log(this.receptionDetails);
            
            Application.events.dispatch("open_reception", this.reception);

            //console.log("reception:", this.reception);
            //console.log("receptionDetails:", this.receptionDetails);

            $(HtmlPartials.getVaxiReceptionSideview(this.receptionDetails)).appendTo(this.parent.inner);

            await delay(100);

            loaderElm.remove();
            this.parent.elm.find(".map-sideview-inner").removeClass("loading");

            //website, navigate, phone
            if(this.receptionDetails.web!=null&&this.receptionDetails.web!="") {
                let elm = this.parent.inner.find(".reception-details-menu > .website");
                elm.removeClass("disabled");
                elm.off("click");
                elm.on("click", () => {
                    let url:string = placeDetails.website;
                    GADataLayer.link_click(url, window.location.pathname, elm.attr("id"), elm.attr("class"));
                    window.open(this.receptionDetails.web, "_blank");
                });
            } else {
                this.parent.inner.find(".reception-details-menu > .website").addClass("disabled");
            }
            if(this.receptionDetails.phone!=null&&this.receptionDetails.phone!="") {
                let elm = this.parent.inner.find(".reception-details-menu > .phone");
                elm.removeClass("disabled");
                elm.off("click");
                elm.on("click", () => {
                    let url:string = "tel:"+this.receptionDetails.phone;
                    GADataLayer.link_click(url, window.location.pathname, elm.attr("id"), elm.attr("class"));
                    window.open(url);
                });
            } else {
                this.parent.inner.find(".reception-details-menu > .phone").addClass("disabled");
            }

            (() => {
                let elm = this.parent.inner.find(".reception-details-menu > .navigate");
                elm.removeClass("disabled");
                elm.off("click");
                elm.on("click", () => {
                    //@TODO: Use user position of we have it:
                    let url:string = GoogleMaps.getRouteURL(null, new GPSCoordinate(this.reception.position.lat, this.reception.position.lng), null);
                    GADataLayer.link_click(url, window.location.pathname, elm.attr("id"), elm.attr("class"));
                    window.open(url);
                });
            })();
            

            
            let placeDetails = await Application.map.googlemaps.getPlaceDetails(this.receptionDetails.place_id);

            let showPhoto = this.receptionDetails.showPhoto!==false;
            if(showPhoto&&placeDetails.photos!=null&&placeDetails.photos.length>0) {
                let tIndex = this.receptionDetails.photoIndex||0;
                tIndex = Math.min(placeDetails.photos.length-1, Math.max(0, tIndex));
                let photo = placeDetails.photos[tIndex];
                this.parent.inner.find(".reception-details-top > img").attr("src", photo.getUrl());
                
                if(photo.html_attributions!=null&&photo.html_attributions.length>0) {
                    let attributionElm = $("<div class='attribution'>Foto:<br></div>").appendTo(this.parent.inner.find(".reception-details-top"));
                    let cnt = 0;
                    for(let m in photo.html_attributions) {
                        let cAttribution = photo.html_attributions[m];
                        if(cnt>0) {
                            $(`<br>`).appendTo(attributionElm);
                        }
                        let attributorElm = $(cAttribution).appendTo(attributionElm);
                        attributorElm.find("a").attr("target", "_blank");
                        if(attributorElm[0].tagName.toLowerCase()=="a") attributorElm.attr("target", "_blank");
                        cnt++;
                    }
                }

            }

            if(this.receptionDetails.group!=null&&MapSideViewContent.groupLogos[this.receptionDetails.group]!=null) {
                $("<div class='group-logo'><img src='"+MapSideViewContent.groupLogos[this.receptionDetails.group]+"' /></div>").appendTo(this.parent.inner.find(".reception-details-top"));
            }

            if(placeDetails.website!=null&&placeDetails.website!="") {
                let elm = this.parent.inner.find(".reception-details-menu > .website");
                elm.removeClass("disabled");
                elm.off("click");
                elm.on("click", () => {
                    let url:string = this.receptionDetails.web || placeDetails.website;
                    GADataLayer.link_click(url, window.location.pathname, elm.attr("id"), elm.attr("class"));
                    window.open(url, "_blank");
                });
            }
            if(placeDetails.formatted_phone_number!=null&&placeDetails.formatted_phone_number!="") {
                let elm = this.parent.inner.find(".reception-details-menu > .phone");
                elm.removeClass("disabled");
                elm.off("click");
                elm.on("click", () => {
                    let url:string = "tel:"+this.receptionDetails.phone;
                    GADataLayer.link_click(url, window.location.pathname, elm.attr("id"), elm.attr("class"));
                    window.open(url);
                });
            }

            if(this.receptionDetails.hideHours===true||placeDetails.opening_hours==null) {
                this.parent.inner.find(".opening-hours-container").hide();
            } else {
                this.parent.inner.find(".opening-hours-container").show();
                let weekday_text = placeDetails.opening_hours.weekday_text;
                if(weekday_text!=null) {
                    let hoursContainer = this.parent.inner.find(".opening-hours-container > .opening-hours");
                    $(`
                        <div class='weekday monday'>
                            <div class='weekday-label'>Måndag</div>
                            <div class='weekday-hours'></div>
                        </div>
                        <div class='weekday tuesday'>
                            <div class='weekday-label'>Tisdag</div>
                            <div class='weekday-hours'></div>
                        </div>
                        <div class='weekday wednesday'>
                            <div class='weekday-label'>Onsdag</div>
                            <div class='weekday-hours'></div>
                        </div>
                        <div class='weekday thursday'>
                            <div class='weekday-label'>Torsdag</div>
                            <div class='weekday-hours'></div>
                        </div>
                        <div class='weekday friday'>
                            <div class='weekday-label'>Fredag</div>
                            <div class='weekday-hours'></div>
                        </div>
                        <div class='weekday saturday'>
                            <div class='weekday-label'>Lördag</div>
                            <div class='weekday-hours'></div>
                        </div>
                        <div class='weekday sunday'>
                            <div class='weekday-label'>Söndag</div>
                            <div class='weekday-hours'></div>
                        </div>
                    `).appendTo(hoursContainer);
                    for(let m in weekday_text) {
                        let c = weekday_text[m];
                        let spl = c.split(": ");
                        let day = spl[0];
                        let val = spl[1];
                        switch(day.toLowerCase()) {
                            case "måndag":
                                hoursContainer.find(".monday .weekday-hours").html(val);
                                break;
                            case "tisdag":
                                hoursContainer.find(".tuesday .weekday-hours").html(val);
                                break;
                            case "onsdag":
                                hoursContainer.find(".wednesday .weekday-hours").html(val);
                                break;
                            case "torsdag":
                                hoursContainer.find(".thursday .weekday-hours").html(val);
                                break;
                            case "fredag":
                                hoursContainer.find(".friday .weekday-hours").html(val);
                                break;
                            case "lördag":
                                hoursContainer.find(".saturday .weekday-hours").html(val);
                                break;
                            case "söndag":
                                hoursContainer.find(".sunday .weekday-hours").html(val);
                                break;
                        }
                    }
                } else {
                    this.parent.inner.find(".opening-hours-container").hide();
                }
            }
        })();
    }
    destroy(): Promise<void> {
        return new Promise((resolve, reject) => {
            Application.events.dispatch("close_reception", this.reception);
            resolve();
        });
    }
    onCloseButtonClick() {
        Application.stateManager.setPath("/");
    }
}